module.exports = __webpack_public_path__ + "img/pCorte.258bb817.jpg";